import styled from "styled-components";

export const Container = styled.div`
  padding: 64px 0;
  background-color: ${({ color }) => (color ? color : "#fff")};
`;

export const Wrapper = styled.div`
  max-width: 510px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  .gatsby-image-wrapper {
    width: 100%;
    height: auto;
  }
`;
